import Data from '../States/Data';
import Helper from './Helper';
import Pattern from './Pattern';

export default class Scripture {
	static async bookCodeByName(name) {
		const mapping = await Data.absolute('mapping');
		for (const code in mapping.books) {
			const item = mapping.books[code];
			if (item.includes(name.toLowerCase()))
				return code;
		}
	}

	static async bookByCode(code) {
		let book = '';
		const version = await Data.relative('version');
		scan:
			for (const testament of version.testaments)
				for (const item of testament.books)
					if (item.code === code) {
						book = item;
						break scan;
					}

		return book;
	}

	static async bookNameByCode(code) {
		const book = await Scripture.bookByCode(code);
		return book.name;
	}

	static async reference(name) {
		const reference = {};
		const label = name.replace(/\s+vers\s+/i, ':');
		const parts = label.match(/([0-9]+\s*)*([^0-9]+)([0-9]+)([\:\-0-9\s]+)*/);
		if (parts) {
			const number = parts[1] || '';
			let book = `${number}${parts[2]}`.trim();
			book = await Scripture.bookCodeByName(book);
			if (book) {
				reference.book = book;
				reference.name = parts[0];
				reference.chapter = parts[3];
				if (parts[4]) {
					let range = parts[4].trim();
					range = range.replace(':', '').split('-');
					if (Helper.undefined(range[1])) range[1] = range[0];

					const verses = [];
					for (let number = parseInt(range[0]); number <= parseInt(range[1]); number++)
						verses.push(number);

					reference.verses = verses;
				}
			}
		}

		return reference;
	}

	static async infoByCode(code) {
		const parts = code.split('_');
		const book = await this.bookByCode(parts[0]);

		const info = {code};
		info.book = {
			code: parts[0] || '',
			uri: parts[0] ? book.uri : '',
			name: parts[0] ? book.name : ''
		};

		info.chapter = {
			code: parts[1] ? `${parts[0]}_${parts[1]}` : '',
			uri: parts[1] ? `${info.book.uri}/${parts[1]}` : '',
			name: parts[1] ? `${info.book.name} ${parts[1]}` : '',
			number: parts[1] || ''
		};

		info.verse = {
			code: parts[2] ? `${parts[0]}_${parts[1]}_${parts[2]}` : '',
			uri: parts[2] ? info.chapter.uri : '',
			name: parts[2] ? `${info.chapter.name}:${parts[2]}` : '',
			number: parts[2] || ''
		};

		return info;
	}

	static async sortVerses(verses) {
		const mapping = await Data.absolute('mapping');
		const book_keys = Object.keys(mapping.books);

		const list = {};
		for (const verse of verses) {
			const info = await this.infoByCode(verse);
			const book = book_keys.indexOf(info.book.code) + 1;
			const position = (book * 1000000) + (info.chapter.number * 1000) + parseInt(info.verse.number);
			list[verse] = position;
		}

		const sorted = Object.keys(list).sort((a, b) => list[a] - list[b]);
		return sorted;
	}

	static verseByChapter(chapter, verse) {
		let scripture = chapter;
		scripture = Pattern.replace(scripture, /<span\sdata-type="char"\sdata-style="sc">(.+?)<\/span>/ig, '$1');
		scripture = Pattern.replace(scripture, /<span\sdata-type="ref"[^\<]+?<\/span>/ig, ' ');
		scripture = Pattern.replace(scripture, /<span\sdata-type="char"[^\<]+?<\/span>/ig, ' ');
		scripture = Pattern.replace(scripture, /<span\sdata-type="note"[^\<]+?<\/span>/ig, ' ');
		scripture = Pattern.replace(scripture, /<i\sclass="fa[^\<]+?<\/i>/ig, ' ');
		scripture = Pattern.replace(scripture, /(<p>|<\/p>)/ig, ' ');
		scripture = Pattern.replace(scripture, /(<x\-v>|<\/x\-v>)/ig, '');
		scripture = Pattern.replace(scripture, /[ ]{2,}/ig, ' ');

		const pattern = `<a\\sdata-verse="${verse}">[0-9]+</a>(.+?)(?:<a|<h3|$)`;
		const expression = new RegExp(pattern, 'im');
		scripture = Pattern.get(scripture, expression);
		scripture = scripture.trim();
		return scripture;
	}

	static async maxChapter(code) {
		let max = 0;
		const book = await Data.relative(`books/${code}`);
		for (let chapter of book.chapters) {
			const number = parseInt(chapter.number);
			if (number > max)
				max = number;
		}

		return max;
	}

	static async changeChapter(code, previous) {
		const current = await Scripture.infoByCode(code);
		const max = await Scripture.maxChapter(current.book.code);

		let info = {};
		let change_number = parseInt(current.chapter.number);
		change_number = previous ? (change_number - 1) : (change_number + 1);
		if (previous ? (change_number < 1) : (change_number > max)) {
			let change_book = previous ? 'REV' : 'GEN';
			let previous_book = change_book;
			let capture_book = false;
			const mapping = await Data.absolute('mapping');
			for (let book in mapping.books) {
				if (capture_book) {
					change_book = book;
					break;
				}
				else if (previous && (book === current.book.code)) {
					change_book = previous_book;
					break;
				}
				else if (!previous && (book === current.book.code))
					capture_book = true;

				previous_book = book;
			}

			change_number = previous ? await Scripture.maxChapter(change_book) : 1;
			info = await Scripture.infoByCode(`${change_book}_${change_number}`);
		}
		else info = await Scripture.infoByCode(`${current.book.code}_${change_number}`);

		return info;
	}

	static async previousChapter(code) {
		return Scripture.changeChapter(code, true);
	}

	static async nextChapter(code) {
		return Scripture.changeChapter(code);
	}
}